import { alias } from '@ember/object/computed';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  name: attr(String),
  userImageURL: alias('userImageUrl'),
  userImageUrl: attr(String)
});